import { ModalContext } from '#pplx/frontend/aether/modals/context/ModalContext.js';
import { assertDefined } from '#pplx/frontend/common/type_utils/assertDefined.js';
import { useInstrumentationParentScope } from '#pplx/frontend/framework/instrumentation/useInstrumentationParentScope.js';
import { useContext, useMemo } from 'react';
const ASSERTION_ERR = 'useModalContext must be used within a ModalProvider';
/**
 * Returns the modal launcher handlers, automatically threading the caller's
 * instrumentation scope chain through to the modal renderer.
 *
 * Captures `useInstrumentationParentScope()` at the hook call site (during
 * the caller's render) and forwards it through `ModalContext`'s internal
 * options bag. `<ModalStateRenderer>` re-injects the captured chain via
 * `<InstrumentationInheritedScope>` so the modal's `track()` calls resolve
 * under the caller's chain rather than orphaned at the renderer's tree
 * position.
 *
 * Modals can opt out of inherited chain by mounting `<InstrumentationScope
 * isolated>` at their own root.
 */
export function useModalContext() {
    const context = useContext(ModalContext);
    assertDefined(context, ASSERTION_ERR);
    const callSiteScope = useInstrumentationParentScope();
    return useMemo(() => ({
        openModal: (modal, props, options) => context.openModal(modal, props, options, { inheritScope: callSiteScope }),
    }), [context, callSiteScope]);
}
//# sourceMappingURL=useModalContext.js.map